module.exports = __webpack_public_path__ + "static/img/default_img_servererror.0d800b26.png";